import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'
import { faBars } from '@fortawesome/pro-solid-svg-icons'

import { digObject } from '@campaignhub/javascript-utils'

import Box from '../../../Box'
import DynamicInput from '../../../DynamicInput'
import FormField from '../../../FormField'
import Grid from '../../../Grid'
import Link from '../../../Link'

const ConfigurationOptions = (props) => {
  const {
    callbacks: { deleteModule, updateModuleOptions },
    configOptions,
    customOptions,
    moduleKey,
    moduleTitle,
    parentId,
  } = props

  const hasConfigOptions = configOptions && !!Object.values(configOptions).length

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderBottom="0"
      borderColor="lineColor"
      borderTopLeftRadius="5px"
      borderTopRightRadius="5px"
      flexDirection="column"
    >
      <Box
        borderBottom={hasConfigOptions ? '1px dashed' : 'none'}
        borderColor="lineColor"
        justifyContent="space-between"
        padding="large"
      >
        <Box>Edit {moduleTitle}</Box>

        <Box justifyContent="flex-end" width="44px">
          <Link
            greyLink
            textProps={{ marginRight: 'medium' }}
            onClick={() => deleteModule({ moduleKey, parentId })}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </Link>

          <Link greyLink>
            <FontAwesomeIcon icon={faBars} />
          </Link>
        </Box>
      </Box>

      {hasConfigOptions && (
        <Grid
          gridGap="medium"
          gridAutoRows="1fr"
          gridTemplateColumns="repeat(auto-fill, minmax(160px, 1fr))"
          padding="large"
          paddingBottom="0"
        >
          {Object.values(configOptions).map((option) => {
            const {
              component, inputType, key, label, optionKey, values
            } = option

            const currentValue = digObject(customOptions, `${optionKey}.${key}`)

            return (
              <FormField key={key} label={label}>
                <DynamicInput
                  currentValue={currentValue}
                  inputComponent={component}
                  inputType={inputType}
                  onChange={e => updateModuleOptions({
                    moduleKey,
                    optionKey,
                    paramKey: key,
                    value: e.target.value,
                  })}
                  style={{ marginBottom: 16 }}
                  values={values}
                />
              </FormField>
            )
          })}
        </Grid>
      )}
    </Box>
  )
}

ConfigurationOptions.propTypes = {
  callbacks: PropTypes.shape({
    deleteModule: PropTypes.func.isRequired,
    updateModuleOptions: PropTypes.func.isRequired,
  }).isRequired,
  configOptions: PropTypes.object,
  customOptions: PropTypes.object,
  moduleKey: PropTypes.string.isRequired,
  moduleTitle: PropTypes.string.isRequired,
  parentId: PropTypes.string.isRequired,
}

export default ConfigurationOptions